export default __webpack_public_path__ + "static/media/Money_Bill_16_9.c597e2f0.png";